import { theme } from '../../../tailwind.config';
import { ETaskPriority } from 'services/TaskManagementApi/types/TaskManagementResponse';

export const taskPriorities = [
  { value: ETaskPriority.LOW, label: 'Low', color: theme.colors['status-confirmed'] },
  { value: ETaskPriority.MEDIUM, label: 'Medium', color: theme.colors['inv-yellow'] },
  { value: ETaskPriority.HIGH, label: 'High', color: theme.colors['status-cancelled'] },
];
